module.exports = __webpack_public_path__ + "img/customerService.4b831cb.png";